<template>
    <div class="classification-tree-item">
        <div class="classification-header">
            <div class="classification-info">
                <i :class="getIconClass(classification.type)" class="me-2"></i>
                <strong>{{ classification.name }}</strong>
                
                <span v-if="classification.is_required" class="badge bg-danger ms-2">
                    Obrigatória
                </span>
                <span v-if="classification.is_price_modifier" class="badge bg-warning ms-2">
                    Modifica Preço
                </span>
            </div>

            <div class="classification-actions">
                <button 
                    type="button" 
                    class="btn btn-sm btn-outline-primary me-2"
                    @click="$emit('add-child', classification.id)"
                    title="Adicionar sub-classificação"
                >
                    <i class="fas fa-plus"></i>
                </button>
                <button 
                    type="button" 
                    class="btn btn-sm btn-outline-secondary me-2"
                    @click="$emit('edit', classification)"
                    title="Editar"
                >
                    <i class="fas fa-edit"></i>
                </button>
                <button 
                    type="button" 
                    class="btn btn-sm btn-outline-danger"
                    @click="$emit('delete', classification.id)"
                    title="Deletar"
                >
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>

        <!-- Children -->
        <div v-if="classification.children && classification.children.length > 0" class="children-classifications">
            <classification-tree-item 
                v-for="child in classification.children" 
                :key="child.id"
                :classification="child"
                :segment-id="segmentId"
                @add-child="$emit('add-child', $event)"
                @edit="$emit('edit', $event)"
                @delete="$emit('delete', $event)"
                @refresh="$emit('refresh')"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClassificationTreeItem',
    props: {
        classification: {
            type: Object,
            required: true
        },
        segmentId: {
            type: Number,
            required: true
        }
    },
    methods: {
        getIconClass(type) {
            const icons = {
                'select': 'fas fa-list',
                'text': 'fas fa-font',
                'number': 'fas fa-hashtag',
                'date': 'fas fa-calendar'
            };
            return icons[type] || 'fas fa-tag';
        }
    }
};
</script>

<style scoped>
.classification-tree-item {
    margin-bottom: 10px;
}

.classification-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #f8f9fa;
    border-left: 3px solid #007bff;
    border-radius: 4px;
}

.classification-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1;
}

.classification-actions {
    display: flex;
    gap: 5px;
    margin-left: 10px;
}

.children-classifications {
    margin-left: 20px;
    margin-top: 10px;
    padding-left: 10px;
    border-left: 2px dashed #dee2e6;
}

.badge {
    font-size: 0.75rem;
    padding: 0.35rem 0.65rem;
}

.btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}
</style>
